import { Component, OnInit, TemplateRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UsersService, ErrorService, TreeService } from '@shared/services';
import { Subject } from 'rxjs';
import { takeUntil, first } from 'rxjs/operators';
import { environment } from '@environment/environment';


@Component({
  selector: 'app-buildingdetailspopup',
  templateUrl: './buildingdetailspopup.component.html',
  styleUrls: ['./buildingdetailspopup.component.scss']
})
export class BuildingdetailspopupComponent implements OnInit {

   constructor(
      private modalService: BsModalService,
      private _treeService: TreeService,
    ) { }

  ngOnInit(): void {
  }
  @ViewChild('buildingInfoForm', { static: true }) BuildingInfoModal: TemplateRef<any>;
    private _unsubscribeAll$ = new Subject<void>();


  modalRefBuilding: BsModalRef | null;
  currentLocation : any;

   openModal(locId): void {

    this.getLocationById(locId);
         const configs = {
                keyboard: false,
                ignoreBackdropClick: true,
               class: ' modal-lg modal-primary  ModelPopUpLayoutFilterPopUps commenModel  fadeInCenter',
                animated: false
              };
    
    this.modalRefBuilding = this.modalService.show(this.BuildingInfoModal, configs);
  }

    getLocationById(locId){
        this._treeService
              .Getlocationbyid(locId)
              .pipe(takeUntil(this._unsubscribeAll$), first())
              .subscribe(
                (result) => {
                  this.currentLocation = result.data;
                  console.log('location load', this.currentLocation);
                },
                (error) => {
                  console.error('Error fetching contact:', error);
                }
              );

      }

        closeLocationDetailsModal() {
          this.modalRefBuilding.hide();
      }

          ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

}
